import { io } from "socket.io-client";

const url = import.meta.env.VITE_API_URL.length === 1 ? window.location.origin : import.meta.env.VITE_API_URL;

// Substitua pela URL do seu backend
const socket = io(url, {
  transports: ["websocket"], // Evita polling, melhora desempenho
  reconnection: true, // Reconectar automaticamente,
});

export default socket;
